import React from "react";
import { Box, Typography, Button, Table, TableBody, TableCell, TableContainer, TableRow } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import colors from "../../../../assets/v3/base/colors";

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(3),
  },
  title: {
    color: colors.dark.main,
    marginBottom: theme.spacing(1),
    fontWeight: 600,
  },
  subtitle: {
    color: colors.secondary.main,
    marginBottom: theme.spacing(2),
  },
  tableCell: {
    padding: theme.spacing(1),
    borderBottom: "none",
  },
  key: {
    color: colors.secondary.main,
    fontWeight: 500,
  },
  value: {
    color: colors.dark.main,
    fontWeight: "bold",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: theme.spacing(2),
    marginTop: theme.spacing(3),
  },
  cancelButton: {
    color: colors.secondary.main,
    border: `1px solid ${colors.secondary.main}`,
    backgroundColor: colors.background.default,
    "&:hover": {
      backgroundColor: colors.background.default,
    },
  },
  confirmButton: {
    color: colors.white.main,
    backgroundColor: colors.success.main,
    "&:hover": {
      backgroundColor: colors.success.main,
    },
  },
}));

/**
 * ConfirmationStage Component
 * 
 * Handles the confirmation step of the registration form.
 * Displays confirmation content with all entered details.
 * 
 * Separation of Concerns:
 * - Only handles UI rendering for confirmation content
 * - Receives all data and callbacks via props
 * - No business logic or API calls
 */
const ConfirmationStage = ({
  haveSchoolOrCollegeFilter,
  haveZonesFilter,
  schoolOrCollege,
  zone,
  branch,
  branchesData,
  grade,
  boards,
  phoneNumber,
  handleConfirmClick,
  handleCancelClick,
  renderOptionText,
}) => {
  const classes = useStyles();

  const keyVals = {
    ...(haveSchoolOrCollegeFilter && {
      Type:
        schoolOrCollege === "school"
          ? "School"
          : schoolOrCollege === "college"
          ? "College"
          : "",
    }),
    ...(haveZonesFilter && {
      Zone: zone ? zone.zoneName : "",
    }),
    Branch:
      branchesData && branch && branchesData[branch]
        ? branchesData[branch].branchName
        : "",
    "Seeking Admission": renderOptionText(grade),
    "Board of the school last studied": boards,
    "Father Phone No": phoneNumber,
  };

  return (
    <Box className={classes.container}>
      <Typography variant="h5" className={classes.title}>
        Confirm Details
      </Typography>
      <Typography variant="body2" className={classes.subtitle}>
        Please confirm your details before proceeding.
      </Typography>
      <TableContainer>
        <Table>
          <TableBody>
            {Object.entries(keyVals).map(([key, value]) => (
              <TableRow key={key}>
                <TableCell component="th" scope="row" className={classes.tableCell}>
                  <Typography variant="body2" className={classes.key}>
                    {key}
                  </Typography>
                </TableCell>
                <TableCell className={classes.tableCell}>
                  <Typography variant="body2" className={classes.value}>
                    : {value}
                  </Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Box className={classes.buttonContainer}>
        <Button
          onClick={handleCancelClick}
          className={classes.cancelButton}
          variant="outlined"
        >
          Back
        </Button>
        <Button
          onClick={handleConfirmClick}
          className={classes.confirmButton}
          variant="contained"
        >
          Confirm
        </Button>
      </Box>
    </Box>
  );
};

export default ConfirmationStage;

